import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, ShieldCheck, Key, Lightbulb, CheckCircle2 } from 'lucide-react';
export function ContentSections() {
  return <div className="w-full bg-brand-dark py-24" data-id="element-9">
      <div className="max-w-5xl mx-auto px-6 space-y-32" data-id="element-10">
        {/* Section 1: The Hook */}
        <motion.section initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="relative" data-id="element-11">
          <div className="absolute -left-4 md:-left-8 top-0 w-1 h-full bg-gradient-to-b from-brand-pink to-transparent rounded-full" data-id="element-12"></div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-13">
            ¿Has sentido que las mejores oportunidades inmobiliarias se te
            escapan de las manos por no tener la información a tiempo?
          </h2>
          <div className="text-lg text-gray-300 space-y-4 leading-relaxed" data-id="element-14">
            <p data-id="element-15">
              Querétaro Capital ya se saturó. El Marqués alcanzó su tope de
              precios. Pero en San Juan del Río, el capital apenas está
              encontrando su mejor terreno.
            </p>
            <p data-id="element-16">
              El Nearshoring está desplazando miles de millones de dólares hacia
              esta zona, y el 21 de julio, los líderes del sector revelarán
              exactamente dónde se va a construir el futuro.
            </p>
          </div>
        </motion.section>

        {/* Section 2: Benefits */}
        <motion.section initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-white" data-id="element-18">
            Lo que vas a lograr en esta Cumbre
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-19">
            <div className="bg-brand-gray p-8 rounded-2xl border border-white/5 hover:border-brand-pink/30 transition-colors group" data-id="element-20">
              <div className="w-12 h-12 rounded-xl bg-brand-pink/10 flex items-center justify-center text-brand-pink mb-6 group-hover:scale-110 transition-transform" data-id="element-21">
                <TrendingUp className="w-6 h-6" data-id="element-22" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-23">
                Networking de 9 Cifras
              </h3>
              <p className="text-gray-400" data-id="element-24">
                Conecta con desarrolladores, dueños de tierra y empresarios que
                ya están operando en la zona.
              </p>
            </div>

            <div className="bg-brand-gray p-8 rounded-2xl border border-white/5 hover:border-brand-pink/30 transition-colors group" data-id="element-25">
              <div className="w-12 h-12 rounded-xl bg-brand-pink/10 flex items-center justify-center text-brand-pink mb-6 group-hover:scale-110 transition-transform" data-id="element-26">
                <ShieldCheck className="w-6 h-6" data-id="element-27" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-28">
                Certeza Jurídica y Técnica
              </h3>
              <p className="text-gray-400" data-id="element-29">
                Obtén claridad sobre los planes de infraestructura vial y
                logística de 2026 a 2029.
              </p>
            </div>

            <div className="bg-brand-gray p-8 rounded-2xl border border-white/5 hover:border-brand-pink/30 transition-colors group" data-id="element-30">
              <div className="w-12 h-12 rounded-xl bg-brand-pink/10 flex items-center justify-center text-brand-pink mb-6 group-hover:scale-110 transition-transform" data-id="element-31">
                <Key className="w-6 h-6" data-id="element-32" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-33">
                Oportunidades 'Off-Market'
              </h3>
              <p className="text-gray-400" data-id="element-34">
                Acceso a proyectos de inversión que aún no salen a preventa
                pública.
              </p>
            </div>

            <div className="bg-brand-gray p-8 rounded-2xl border border-white/5 hover:border-brand-pink/30 transition-colors group" data-id="element-35">
              <div className="w-12 h-12 rounded-xl bg-brand-pink/10 flex items-center justify-center text-brand-pink mb-6 group-hover:scale-110 transition-transform" data-id="element-36">
                <Lightbulb className="w-6 h-6" data-id="element-37" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-38">
                Visión de Expertos
              </h3>
              <p className="text-gray-400" data-id="element-39">
                Conferencias magistrales sobre Nearshoring y tendencias que
                dictarán los precios del suelo el próximo año.
              </p>
            </div>
          </div>
        </motion.section>

        {/* Section 3: Value Stack */}
        <motion.section initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="bg-gradient-to-br from-brand-gray to-brand-dark border border-brand-pink/20 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-40">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-pink/10 blur-[80px] rounded-full pointer-events-none" data-id="element-41"></div>

          <div className="relative z-10 text-center max-w-2xl mx-auto" data-id="element-42">
            <h2 className="text-3xl font-bold mb-6 text-white" data-id="element-43">
              Para asegurar que tu asistencia sea productiva
            </h2>
            <p className="text-gray-300 mb-8" data-id="element-44">Al registrarte hoy, recibirás:</p>

            <div className="flex items-center justify-center gap-3 text-xl md:text-2xl font-semibold text-white mb-8 bg-white/5 py-4 px-6 rounded-xl border border-white/10" data-id="element-45">
              <CheckCircle2 className="text-brand-pink w-8 h-8" data-id="element-46" />
              Acceso Total a la Cumbre
            </div>

            <div className="space-y-2" data-id="element-47">
              <p className="text-gray-400 line-through text-lg" data-id="element-48">
                Valor Regular: $2,500 MXN
              </p>
              <p className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-brand-pink to-purple-400" data-id="element-49">
                PRECIO HOY: $0.00 MXN
              </p>
            </div>
          </div>
        </motion.section>
      </div>
    </div>;
}